import { connect } from 'react-redux';
import { getIsLoggedIn, getCurrentUserHasCore } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        isLoggedIn: getIsLoggedIn(state),
        hasCoreMembership: getCurrentUserHasCore(state)
    });
export default connect(mapStateToProps);

//# sourceMappingURL=UserSymbolsPopup.container.js.map